module.exports = __webpack_public_path__ + "static/mountain-left-15aa06e7c86b52da99506bf8cace9bf8.webp";